import { getContext } from 'svelte';
export const NavMenuContextKey = Symbol('Nav Menu');
export const NavMenuGroupKey = Symbol('Nav Menu Group');
export const getNavMenuContext = () => getContext(NavMenuContextKey);
export const getNavMenuGroupContext = () => getContext(NavMenuGroupKey);
